export default "__VITE_ASSET__MF8czghX__"